import assert from 'assert'

import { PopupDatabase } from '@/popup/storage/Database'
import { makeToast } from '@/popup/utils/toasts'
import { useUIStore } from '@/popup/store/UIStore'
import { AppNotification } from '@/shared/models/AppNotification'
import { InternalMethods } from '@/shared/apis/messages'
import { useGlobals } from '@/popup/compositions/useGlobals'

const updateToast = (toast: AppNotification) =>
  PopupDatabase.put('notifications', toast)

const addSomethingWentWrongError = (message: string): Promise<void> => {
  return useGlobals().sendMessage({
    method: InternalMethods.ADD_SOMETHING_WENT_WRONG_ERROR,
    payload: { message },
  })
}

export function assertAndShowSomethingWentWrongError(
  value: unknown,
  message: string
): asserts value {
  if (!value) {
    addSomethingWentWrongError(message)
    assert(value, message)
  }
}

export const useNotifications = () => {
  const uiStore = useUIStore()

  const clearToasts = () => uiStore.setToast()
  let timeout: NodeJS.Timeout

  const showToast = (toast?: AppNotification) => {
    clearTimeout(timeout)
    if (!toast) {
      timeout = setTimeout(() => uiStore.setToast(), 1000)
      return
    }

    uiStore.setToast(makeToast(toast))
    if (!toast.isPersistent) {
      setTimeout(() => PopupDatabase.removeNotification(toast.id), 2000)
    }
  }

  return {
    clearToasts,
    showToast,
    updateToast,
    addSomethingWentWrongError,
  }
}
